import uniqBy from 'ramda/es/uniqBy';
import { Api } from '../common/ajax/Api';
import AbstractPiniaModel from './AbstractPiniaModel';
import { useMarketingTextsStore } from '../pinia/stores/marketingTexts';


export class MarketingTexts extends AbstractPiniaModel {
    //#region Instance Code
        constructor(src) { super(src); }


        id()            { return this.source.id; }
        professionId()  { return this.source.profession_id; }
        slot()          { return this.source.slot; }
        content()          { return this.source.content; }
       

        static create(src) { return new MarketingTexts(src); }
        static createFromId(id)           { return this.findById(id); }

        static piniaStore() { return useMarketingTextsStore(); }


        static select(marketingText)       { this.selectById(marketingText.id()); }

        static setSelectedOnes(categories) { this.dispatch('setAllMarketingTexts', categories.map(c=>c.getSource())); }

        static findById(id)      { return this.create(this.piniaStore().findById(id)); }


        static loadFromBackend() {
            return Api.getMarketingTexts()
                       .then( result => this.dispatch('setAllMarketingTexts', result.data) )
                       .catch( err => checkApiResponseForAuth(this.ebus(), err) )
        }
    
        static getRemote() {
            if (this.piniaStore().allMarketingTexts && this.piniaStore().allMarketingTexts.length > 0)
                 return Promise.resolve(this.piniaStore().allMarketingTexts)
            return this.loadFromBackend().then(() => this.piniaStore().allMarketingTexts)
        }

}
